export default __webpack_public_path__ + "static/compareItemImg1-2d8e4a4ae10274ddc27ae5d39796c567.webp";